// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f198974e","647":"ba9d7afa"}[chunkId] + ".chunk.js";
};